import './ActiveTrips.styles.scss';
import { Button, Col, Row } from 'react-bootstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { publicURL } from '../../../../utils/axiosInstance';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Trip from '../Trip/Trip';

interface ActiveTripsProps {
  trips: Array<any>;
}

function ActiveTrips({ trips }: ActiveTripsProps) {
  const history = useHistory();
  const goToSearch = () => {
    history.push('/');
  };

  return (
    <Row lg={12} className={'m-0 p-3'}>
      {trips && trips.map(trip => <Trip trip={trip} property={trip.Property} />)}
      {!trips ||
        (!trips.length && (
          <Col className="no-trips-col">
            <LazyLoadImage src={`${publicURL}/images/trips/no-trips.jpeg`} className="no-trip-img" />
            <div className="p-2">
              <div>You have no active bookings.</div>
              <div>
                If you want to go on a trip, you can go to the search for suitable places or{' '}
                <Link to="/help-center" className={'__primary-text-color font-weight-bold'}>
                  contact us
                </Link>{' '}
                for help in choosing.
              </div>
            </div>
            <Button variant="dark" className="m-2 go-to-search-btn" onClick={goToSearch}>
              Go To Search
            </Button>
          </Col>
        ))}
    </Row>
  );
}

export default ActiveTrips;
